export const gridsettings = {
  containerStatus : 'gridContainerStatus',
  gensetStatus : 'gridGensetStatus',
};
